import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardFooter, Col, Input, Label, Row } from 'reactstrap';

import { LoadLogoHeader } from '../../../../Layouts/LoadLogo';
import { downloadImageBase64, updatePage, uploadFile, uploadFileImage } from '../../../../slices/thunks';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import OPlaceholder from '../../../../Components/OElements/OPlaceholder';

const CoverPage = ({ page, period }) => {
    const dispatch = useDispatch();
    const [image, setImage] = useState(null);
    const monthMap = { 'JAN': '01', 'FEB': '02', 'MAR': '03', 'APR': '04', 'MAY': '05', 'JUN': '06', 'JUL': '07', 'AUG': '08', 'SEP': '09', 'OCT': '10', 'NOV': '11', 'DEC': '12' };
    const [monthStr, year] = period.split(' ');
    const formattedPeriod = `${monthMap[monthStr]}|${year.slice(-2)}`;

    const selector = createSelector(
        state => state.FileManager,
        data => ({
            image_base64: data.image_base64,
            isLoadingImage: data.isLoadingImage
        })
    );

    const { image_base64, isLoadingImage } = useSelector(selector);


    useEffect(() => {
        dispatch(downloadImageBase64(page.elements[0].image.url));
    }, [page.elements[0].image.url]);

    useEffect(() => {
        if (!isLoadingImage) {
            setImage(image_base64)
        }
    }, [image_base64, isLoadingImage]);



    const [inputValue, setInputValue] = useState(page.name);

    useEffect(() => {
        const handler = setTimeout(() => {
            if (inputValue !== page.name) {
                updateTitlePage(page, inputValue);
            }
        }, 2000);

        return () => {
            clearTimeout(handler);
        };
    }, [inputValue]);



    const updateElement = async (page, field, value) => {
        // Si page.elements es null o undefined, lo inicializamos como un array vacío
        const elements = page.elements ?? [];
        // Encontrar el índice del elemento que tiene el campo 'field' igual a 'value'
        const elementIndex = elements.findIndex(el => el.hasOwnProperty(field));

        // Si el elemento ya existe, lo actualizamos
        if (elementIndex !== -1) {
            return {
                ...page,
                elements: elements.map((el, elIndex) => {
                    if (elIndex === elementIndex) {
                        return {
                            ...el,
                            [field]: value, // Aquí puedes actualizar el valor si es necesario
                        };
                    }
                    return el;
                }),
            };
        } else {
            // Si no existe, lo agregamos como un nuevo elemento
            return {
                ...page,
                elements: [...elements, { [field]: value }],
            };
        }
    };

    const updateTitlePage = (page, title) => {
        // Actualizar el título de la página
        const updatedPage = {
            ...page,  // Hacemos una copia del objeto para mantener inmutabilidad
            name: title
        };
        // Disparamos la acción de actualización con el nuevo objeto de la página
        dispatch(updatePage(updatedPage));
    };


    const handleFileChange = async (event) => {
        const file = event.currentTarget.files[0];
        if (!file) {
            console.error("No se seleccionó ningún archivo.");
            return;
        }
        const formData = new FormData();
        formData.append('file', file);

        try {
            const responseUploadFile = await dispatch(uploadFileImage({ formData })).unwrap();
            const updatedPage = await updateElement(page, "image", responseUploadFile);
            dispatch(updatePage(updatedPage))

            if (file) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    const base64String = reader.result;
                    setImage(base64String);
                };
                reader.readAsDataURL(file); // Convierte el archivo en base64
            }

        } catch (error) {
            console.error('Error al subir archivo:', error);
        }
    };


    return (

        <Row>
            <Col lg={12}>
                <Label for="document_evidence">
                    Subir imagen de fondo
                </Label>
                <Input
                    id="document_evidence"
                    name="document_evidence"
                    type="file"
                    accept="image/*" // Acepta solo archivos de imagen
                    onChange={handleFileChange}
                />
            </Col>
            <Col lg={12} className='mt-4'>
                <Card style={{ display: 'flex', flexDirection: 'row' }}>
                    <Row style={{ height: '100%', width: '100%' }}>
                        {/* Primera columna: Imagen grande */}
                        <Col md={8} style={{ padding: 0 }}>
                            {isLoadingImage ? <OPlaceholder /> :
                                <img className="img-fluid h-100" src={image} alt="Card Background" style={{ objectFit: 'cover' }} />
                            }
                        </Col>

                        {/* Segunda columna: Texto y logo */}
                        <Col md={4} className="bg-primary d-flex flex-column justify-content-between p-4" style={{ color: 'white' }}>
                            <div className="d-flex flex-column align-items-end justify-content-start">
                                <p className="fs-1" style={{ margin: 0, textAlign: 'right', color: '#426BA8' }}>{formattedPeriod}</p>
                                <Input
                                    name='title'
                                    id='title'
                                    className='form-control w-100'
                                    placeholder='Ingrese un título de la portada'
                                    type='text'
                                    value={inputValue} // Vinculamos el estado local al valor del input
                                    onChange={(e) => setInputValue(e.target.value)} // Actualizamos el estado local
                                    style={{ textAlign: 'right' }}
                                />
                                <p className="fs-20" style={{ textAlign: 'right' }}>{'Cooke Aquaculture Chile'}</p>
                            </div>
                            <div className="d-flex justify-content-center">
                                <LoadLogoHeader maxHeight={70} maxWidth={'300px'} />
                            </div>
                        </Col>
                    </Row>
                </Card>

            </Col>
        </Row>
    );
};

export default CoverPage;
